import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const loc = useLocation();
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main key={loc.pathname} className="flex-1 page-enter">
        {children}
      </main>
      <Footer />
    </div>
  );
}
